// Generated by purs version 0.15.15
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Ouroboros_Models_Brands_ErrorMessageText from "../Ouroboros.Models.Brands.ErrorMessageText/index.js";
import * as Ouroboros_Models_Brands_SectionEdits from "../Ouroboros.Models.Brands.SectionEdits/index.js";
import * as Ouroboros_Models_Brands_SectionID from "../Ouroboros.Models.Brands.SectionID/index.js";
import * as Ouroboros_Models_Core_ErrorHandlers from "../Ouroboros.Models.Core.ErrorHandlers/index.js";
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Services_Clients_Interop_IO from "../Ouroboros.Services.Clients.Interop.IO/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
import * as Ouroboros_Services_Clients_Interop_Task from "../Ouroboros.Services.Clients.Interop.Task/index.js";
import * as Ouroboros_Services_Clients_Interop_TaskEither from "../Ouroboros.Services.Clients.Interop.TaskEither/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(Ouroboros_Models_Brands_SectionID.eqSectionID);
var DocumentFinalEditsAction = function (x) {
    return x;
};
var unhandledContentFailure = {
    message: /* #__PURE__ */ Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Document Synthesis Operations are currently unavailable. Please try again later or contact support if the issue persists."),
    info: /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)
};
var toLoadingErrorInput = function (errorValue) {
    var statusCode = (function () {
        if (errorValue.statusCode instanceof Data_Maybe.Nothing) {
            return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
        };
        if (errorValue.statusCode instanceof Data_Maybe.Just) {
            return Ouroboros_Services_Clients_Interop_Option.some(errorValue.statusCode.value0);
        };
        throw new Error("Failed pattern match at Ouroboros.Programs.Controllers.DocumentFinalEdits (line 158, column 7 - line 160, column 40): " + [ errorValue.statusCode.constructor.name ]);
    })();
    var message = Ouroboros_Models_Core_ErrorHandlers.contentErrorMessage({
        type: errorValue.type,
        message: errorValue.message,
        statusCode: statusCode
    });
    return {
        message: message.message,
        info: message.info
    };
};
var runReplaceSection = function (v) {
    return function (documentId) {
        return function (request) {
            return v(documentId)(request);
        };
    };
};
var runNavigate = function (v) {
    return function (path) {
        return v(path);
    };
};
var runLoadingAction = function (v) {
    return v;
};
var runUpdateSectionSuccess = function (env) {
    return function (documentId) {
        return function (updatedSection) {
            return Ouroboros_Services_Clients_Interop_IO.sequenceOk([ Ouroboros_Programs_Capabilities.runStateUpdate(env.updateSection)(updatedSection), runNavigate(env.navigate)(Ouroboros_Programs_Capabilities.runRouteBuilder(env.reviewRoute)(documentId)), runLoadingAction(env.loading.setSuccess) ]);
        };
    };
};
var runDocumentFinalEditsAction = function (v) {
    return v;
};
var readState = function (v) {
    return v;
};
var readOption = function (v) {
    return v;
};
var readFinalEdits = function (env) {
    return readState(Ouroboros_Programs_Capabilities.stateHandleRead(env.finalEdits));
};
var mkDocumentFinalEditsAction = DocumentFinalEditsAction;
var missingDocumentError = {
    message: /* #__PURE__ */ Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Document is not loaded. Return to review and try again."),
    info: /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)
};
var handleReplaceSectionSuccess = function (env) {
    return function (documentId) {
        return function (response) {
            return Ouroboros_Services_Clients_Interop_Task.fromIO(runUpdateSectionSuccess(env)(documentId)(response.updated_section));
        };
    };
};
var handleContentError = function (env) {
    return function (errorValue) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError(toLoadingErrorInput(errorValue))));
    };
};
var documentationPath = "/documentation/drafting/frontend-program-builder/controllers/document_final_edits_controller.md";
var buildRequest = function (sectionId) {
    return function (edits) {
        return {
            edits: Ouroboros_Models_Brands_SectionEdits.makeSectionEdits(edits),
            section_id: sectionId
        };
    };
};
var submitFinalEditsTask = function (env) {
    return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError(missingDocumentError)));
    })(function (document) {
        return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError(unhandledContentFailure)));
        })(function (sectionId) {
            return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
                return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleContentError(env))(handleReplaceSectionSuccess(env)(document.id))(runReplaceSection(env.replaceSection)(document.id)(buildRequest(sectionId)(readFinalEdits(env))));
            })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setLoading)));
        })(readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(env.activeSection)));
    })(readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(env.document)));
};
var buildOnInit = function (env) {
    return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
        return Ouroboros_Services_Clients_Interop_Option.some(mkDocumentFinalEditsAction(runLoadingAction(env.loading.setError(missingDocumentError))));
    })(function (document) {
        return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
        })(function (sectionId) {
            var v = Data_Array.find(function (section) {
                return eq(section.metadata.id)(sectionId);
            })(document.document_contents);
            if (v instanceof Data_Maybe.Nothing) {
                return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
            };
            if (v instanceof Data_Maybe.Just) {
                return Ouroboros_Services_Clients_Interop_Option.some(mkDocumentFinalEditsAction(Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(env.finalEdits))(Data_Maybe.fromMaybe("")(v.value0.section_contents))));
            };
            throw new Error("Failed pattern match at Ouroboros.Programs.Controllers.DocumentFinalEdits (line 76, column 11 - line 81, column 108): " + [ v.constructor.name ]);
        })(readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(env.activeSection)));
    })(readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(env.document)));
};
var mkDocumentFinalEditsController = function (env) {
    return {
        onSubmit: mkDocumentFinalEditsAction(Ouroboros_Programs_Capabilities.runTaskRunner(env.taskRunner)(submitFinalEditsTask(env))),
        onInit: buildOnInit(env)
    };
};
export {
    DocumentFinalEditsAction,
    mkDocumentFinalEditsController,
    runDocumentFinalEditsAction,
    documentationPath
};
//# sourceMappingURL=index.js.map
